import React from 'react';

import './SurveyReadinessInput.css';

interface Props {
  yesLabel: string;
  noLabel: string;
  onYes: () => void;
  onNo: () => void;
  disabled?: boolean;
}

export const SurveyReadinessInput = ({yesLabel, noLabel, onYes, onNo, disabled = false}: Props) => (
  <div className="survey-readiness-input">
    <button
      type="button"
      className="survey-readiness-input__button survey-readiness-input__button--yes"
      disabled={disabled}
      onClick={onYes}
    >
      {yesLabel}
    </button>
    <button
      type="button"
      className="survey-readiness-input__button survey-readiness-input__button--no"
      disabled={disabled}
      onClick={onNo}
    >
      {noLabel}
    </button>
  </div>
);
